<app-loading-bar></app-loading-bar>
<router-outlet></router-outlet>
<app-toast aria-live="polite" aria-atomic="true"></app-toast>
